export { default as ContractDetail } from './ContractDetail.vue'
export { default as RoomDetail } from './RoomDetail.vue'
export { default as RoomProperties } from './RoomProperties.vue'
export { default as LezhuMonitor } from './LezhuMonitor.vue'



// WEBPACK FOOTER //
// ./client/src/components/mixed/index.js